export const Regex={
    email:"",
    phone:"",
    empty:"",
}

